import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import classnames from 'classnames'
import moment from 'moment'
import _ from 'lodash'

import CustomDate from '../../../../../../../../../../../components/CustomDate'
import InactiveIndicatorCell from '../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Cell'
import InactivityIndicatorHeader from '../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Header'
import NoData from '../../../../../../../../../components/Workspace/components/NoData'

import { LOCALE_PREFIX } from '../../constants'

import { precisionFormats } from './constants'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class Trades extends Component {
    static propTypes = {
        activitiesTradesTableChange: PropTypes.func.isRequired,
        block: PropTypes.string.isRequired,
        data: PropTypes.array,
        entId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        filter: PropTypes.object,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        sorted: PropTypes.array,
        translates: PropTypes.shape({
            activities: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            durationFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            durationTo: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            page: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            rowCount: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            rowShow: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            tradeName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            tradeType: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }),
    }

    onTableChange = (changeData) => {
        const { activitiesTradesTableChange, entId, module, level, block } = this.props

        activitiesTradesTableChange(module, block, entId, level, changeData)
    }

    render() {
        const { data, pagination, translates, sorted, intl, filter, isLoading } = this.props

        if (_.isEmpty(data) && _.isEmpty(filter?.activeFilters)) {
            return (
                <div className={'trades-tab-content'}>
                    <NoData text={<FormattedMessage id={`${LOCALE_PREFIX}.noTableData`} />} />
                </div>
            )
        }

        return (
            <div className={'trades-tab-content'}>
                <FilterTable
                    id={'trades-table'}
                    key={'trades-table'}
                    data={data}
                    loading={isLoading}
                    columnsDefinition={[
                        {
                            id: 'activity',
                            accessor: 'inactive',
                            Header: (val) => (
                                <div>
                                    {val.Controls}
                                    <InactivityIndicatorHeader />
                                </div>
                            ),
                            width: 35,
                            Cell: (value) => <InactiveIndicatorCell inactive={_.get(value, 'value', false)} />,
                            sortable: false,
                            filterable: true,
                            filter: {
                                type: 'VALUE',
                                value: _.map(
                                    _.get(filter, 'availableParameters.activity.availableValues', []),
                                    (x) => ({
                                        value: _.get(x, 'value', null),
                                        item: _.get(x, 'title', null),
                                    })
                                ),
                            },
                        },
                        {
                            accessor: 'name',
                            Header: `${translates.tradeName}`,
                            sortable: false,
                            Cell: (cellValue) => (
                                <div className={classnames('wordBreakCell', { inactive: cellValue.original.inactive })}>
                                    {_.get(cellValue, 'value', '')}
                                </div>
                            ),
                        },
                        {
                            id: 'dataType',
                            accessor: 'type',
                            Header: `${translates.tradeType}`,
                            width: 200,
                            Cell: (cellValue) => (
                                <div className={classnames({ inactive: cellValue.original.inactive })}>
                                    {_.get(cellValue, 'value', '')}
                                </div>
                            ),
                            sortable: false,
                            filterable: true,
                            filter: {
                                type: 'VALUE',
                                value: _.map(
                                    _.get(filter, 'availableParameters.dataType.availableValues', []),
                                    (x) => ({
                                        value: _.get(x, 'value', null),
                                        item: _.get(x, 'title', null),
                                    })
                                ),
                            },
                        },
                        {
                            accessor: 'startDate',
                            Header: `${translates.durationFrom}`,
                            width: 100,
                            Cell: (cellValue) => (
                                <span className={classnames({ inactive: cellValue.original.inactive })}>
                                    {!_.isNil(_.get(cellValue, 'value.value', null))
                                        ? moment(_.get(cellValue, 'value.value')).format(
                                              _.get(
                                                  precisionFormats,
                                                  `${_.get(cellValue, 'value.precision', 'default')}`
                                              )
                                          )
                                        : null}
                                </span>
                            ),
                            sortable: true,
                        },
                        {
                            accessor: 'endDate',
                            Header: `${translates.durationTo}`,
                            width: 100,
                            Cell: (cellValue) => (
                                <span className={classnames({ inactive: cellValue.original.inactive })}>
                                    {!_.isNil(_.get(cellValue, 'value.value', null))
                                        ? moment(_.get(cellValue, 'value.value')).format(
                                              _.get(
                                                  precisionFormats,
                                                  `${_.get(cellValue, 'value.precision', 'default')}`
                                              )
                                          )
                                        : null}
                                </span>
                            ),
                            sortable: false,
                        },
                        {
                            accessor: 'suspensionFlag',
                            Header: `${translates.suspension}`,
                            Cell: ({ value, original }) => (
                                <span className={classnames({ inactive: original?.inactive })}>
                                    {value ? (
                                        <>
                                            {intl.formatMessage({ id: 'global.yes' })}
                                            {original?.suspensionStartDate && (
                                                <>
                                                    <span style={{ padding: '0 4px' }}>
                                                        {intl.formatMessage({ id: 'global.date.from' })}
                                                    </span>
                                                    <CustomDate
                                                        date={original?.suspensionStartDate?.value}
                                                        precision={original?.suspensionStartDate?.precision}
                                                    />
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        intl.formatMessage({ id: 'global.no' })
                                    )}
                                </span>
                            ),
                        },
                    ]}
                    settings={{
                        pagination,
                        sorted,
                        filtered: (filter?.activeFilters ?? []).map((actFilter) => ({
                            id: actFilter?.id,
                            value: actFilter?.value || [],
                        })),
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    onTableChange={this.onTableChange}
                    selectable={false}
                    texts={{
                        pagination: {
                            from: intl.formatMessage({ id: 'global.of' }),
                            loading: intl.formatMessage({ id: 'global.loading' }),
                            noData: intl.formatMessage({ id: 'global.noData' }),
                            rows: intl.formatMessage({ id: 'global.rows' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                        filter: {
                            valueTitle: intl.formatMessage({ id: 'global.valueTitle' }),
                            fulltextTitle: intl.formatMessage({ id: 'global.fulltextTitle' }),
                        },
                    }}
                />
            </div>
        )
    }
}
